import { Component, OnInit } from '@angular/core';
import { Chart } from 'chart.js';
import { UtilisateursService } from '../../services/utilisateurs.service';
import { tap } from 'rxjs/operators';

@Component({
  selector: 'app-statistics-global',
  templateUrl: './statistics-global.component.html',
  styleUrls: ['./statistics-global.component.css'],
})
export class StatisticsGlobalComponent implements OnInit {
  chart!: any;
  chart2!: any;
  hommes: number[] = [];
  femmes: number[] = [];
  CountMaleAdmitted : number[] = [];
  CountFmaleAdmitted : number[] = [];
  AllAdmisGender:any[]=[];
  IAhomme: number = 0;
  IAfemme:number = 0;
  DEVhomme:number = 0;
  DEVfemme:number = 0;
  TECHhomme:number = 0;
  TECHfemme:number = 0;
  EBUShomme:number = 0;
  EBUSfemme:number = 0;
  totalHomme:number = 0;
  totalFemme:number = 0;

  NoIAhomme:number = 0;
  NoIAfemme:number = 0;
  NoDEVhomme:number = 0;
  NoDEVfemme:number = 0;
  NoTECHhomme:number = 0;
  NoTECHfemme:number = 0;
  NoEBUShomme:number = 0;
  NoEBUSfemme:number = 0;
  NototalHomme:number = 0;
  NototalFemme:number = 0;
  totalGlobalH:number =0;
  totalGlobalF:number =0;
  totalGlobalHommeFemmeAdmis:number =0;
  totalGlobalHommeFemmeNoAdmis:number =0;
  countAdmis!:  number;
  countNoAdmis!:  number;

  constructor(private utilisateurService: UtilisateursService) {}

  ngOnInit() {
    this.generateGenderChart();
    this.generateCategoryChart();
    this.getGenderMaleFemaleAttmited();
    this.getGenderMaleFemaleNoAttmited();
    this.totalGlobalH = this.totalHomme + this.NototalHomme;
    this.totalGlobalF = this.totalFemme + this.NototalFemme;

    this.getCountAdmisNoadmis();

  }

  //Nombre des hommes, femme admis
  getGenderMaleFemaleAttmited():void{
    this.utilisateurService.getAdmittedByFamilyAndGender().subscribe(
      (sexe)=>{
        (sexe["DÉVELOPPEMENT LOGICIEL"]?.Homme);
        (sexe["DÉVELOPPEMENT LOGICIEL"]?.Femme);
        //// //console.log(sexe["DÉVELOPPEMENT LOGICIEL"])
        this.DEVhomme = sexe["DÉVELOPPEMENT LOGICIEL"]?.Homme != undefined ?  sexe["DÉVELOPPEMENT LOGICIEL"].Homme : 0;
        this.DEVfemme = sexe["DÉVELOPPEMENT LOGICIEL"]?.Femme  != undefined ?  sexe["DÉVELOPPEMENT LOGICIEL"].Femme : 0; 
        this.IAhomme = sexe["INTELLIGENCE ARTIFICIELLE ET DATA"]?.Homme != undefined ? sexe["INTELLIGENCE ARTIFICIELLE ET DATA"].Homme :0;
        this.IAfemme = sexe["INTELLIGENCE ARTIFICIELLE ET DATA"]?.Femme  != undefined ? sexe["INTELLIGENCE ARTIFICIELLE ET DATA"].Femme :0;
        this.TECHhomme = sexe["TECHNOLOGIES EMERGENTES ET CYBERSECURITE"]?.Homme != undefined ? sexe["TECHNOLOGIES EMERGENTES ET CYBERSECURITE"]?.Homme :0;
        this.TECHfemme = sexe["TECHNOLOGIES EMERGENTES ET CYBERSECURITE"]?.Femme  != undefined ? sexe["TECHNOLOGIES EMERGENTES ET CYBERSECURITE"]?.Femme :0;;
        this.EBUShomme = sexe["e-BUSINESS"]?.Homme != undefined ? sexe["e-BUSINESS"].Homme :0;
        this.EBUSfemme = sexe["e-BUSINESS"]?.Femme   != undefined ? sexe["e-BUSINESS"].Femme :0;
        
        this.totalHomme = this.DEVhomme + this.IAhomme + this.TECHhomme + this.EBUShomme;
        this.totalFemme = this.DEVfemme + this.IAfemme + this.TECHfemme + this.EBUSfemme;

        //// //console.log("test admis donnees ",this.totalFemme);
        //// //console.log("test admis donnees ",this.totalHomme )

        this.updateTotalGlobal();
      }
    )
  };

    //Nombre des hommes, femmes non admis
    getGenderMaleFemaleNoAttmited():void{
      this.utilisateurService.getNoAdmitted().subscribe(
        (data) => {
          // data é l liste d'objets
          data.forEach((item: any) => {
            // Vérifier la famille pr chak élément et accumuler les valeurs en conséquence
            switch(item.family) {
              case "DÉVELOPPEMENT LOGICIEL":
                this.NoDEVhomme += item.gender === "Homme" ? 1 : 0;
                this.NoDEVfemme += item.gender === "Femme" ? 1 : 0;
                break;
              case "INTELLIGENCE ARTIFICIELLE ET DATA":
                this.NoIAhomme += item.gender === "Homme" ? 1 : 0;
                this.NoIAfemme += item.gender === "Femme" ? 1 : 0;
                break;
              case "TECHNOLOGIES EMERGENTES ET CYBERSECURITE":
                this.NoTECHhomme += item.gender === "Homme" ? 1 : 0;
                this.NoTECHfemme += item.gender === "Femme" ? 1 : 0;
                break;
              case "e-BUSINESS":
                this.NoEBUShomme += item.gender === "Homme" ? 1 : 0;
                this.NoEBUSfemme += item.gender === "Femme" ? 1 : 0;
                break;
              default:
                break;
            }
          });
    
          // Après avoir itéré sur toutes les données, mettez à jour les totaux et autres informations nécessaires
          this.NototalHomme = this.NoDEVhomme + this.NoIAhomme + this.NoTECHhomme + this.NoEBUShomme;
          this.NototalFemme = this.NoDEVfemme + this.NoIAfemme + this.NoTECHfemme + this.NoEBUSfemme;
    
          //// //console.log("test non admis donnees ",this.NototalFemme);
          //// //console.log("test non admis donnees ",this.NototalHomme )
    
          this.updateTotalGlobal();
        }
      );
    };

        
    // mettre à jr la somme totale
    updateTotalGlobal(): void {
      // Calcul de la somme totale
      this.totalGlobalH = this.totalHomme + this.NototalHomme;
      this.totalGlobalF = this.totalFemme + this.NototalFemme;
      this.totalGlobalHommeFemmeAdmis = this.totalHomme +  this.totalFemme ;
      this.totalGlobalHommeFemmeNoAdmis = this.NototalHomme + this.NototalFemme;
    }



  // Diagmm Repartition du nmbre dadmis par famille de métier et par genre
  generateGenderChart() {
    this.utilisateurService
      .getAdmittedByFamilyAndGender()
      .pipe(
        tap((data) => {
          this.hommes.push(data?.['INTELLIGENCE ARTIFICIELLE ET DATA']?.Homme);
          this.hommes.push(data?.['e-BUSINESS']?.Homme);
          this.hommes.push(data?.['DÉVELOPPEMENT LOGICIEL']?.Homme);
          this.hommes.push(data?.['TECHNOLOGIES EMERGENTES ET CYBERSECURITE']?.Homme);

          this.femmes.push(data?.['INTELLIGENCE ARTIFICIELLE ET DATA']?.Femme);
          this.femmes.push(data?.['e-BUSINESS']?.Femme);
          this.femmes.push(data?.['DÉVELOPPEMENT LOGICIEL']?.Femme);
          this.femmes.push(data?.['TECHNOLOGIES EMERGENTES ET CYBERSECURITE']?.Femme);

          this.setGenderChart(
            'canvasFamily',
            this.hommes,
            this.femmes,
            "Répartition du nombre d'admis par famille de métier et par genre",
            {
              homme: 'rgba(75, 192, 192, 0.2)',
              femme: 'rgba(255, 99, 132, 0.2)',
            }
          );
        })
      )
      .subscribe();
  }
   // Méthode pour dessiner le diagramme Rpartition du nombre d'admis par famille de métier et par genre
   setGenderChart(
    canvasName: string,
    maleData: number[],
    femaleData: number[],
    title: string,
    colors: { homme: string; femme: string }
  ) {
    const canvas = document.getElementById(canvasName) as HTMLCanvasElement;
    const ctx = canvas.getContext('2d');
  
    if (ctx) {
      this.chart = new Chart(ctx, {
        type: 'bar',
        data: {
          labels: ['IA/D', 'E-Bus', 'DEV-LOG', 'TE/Cybs'],
          datasets: [
            {
              label: 'Homme',
              data: maleData,
              backgroundColor: colors.homme,
              borderColor: 'rgb(54, 162, 235)',
              borderWidth: 1,
            },
            {
              label: 'Femme',
              data: femaleData,
              backgroundColor: colors.femme,
              borderColor: 'rgb(255, 99, 132)',
              borderWidth: 1,
            },
          ],
        },
        options: {
          plugins: {
            title: {
              display: true,
              text: title,
            },
          },
          responsive: true,
          interaction: {
            intersect: false,
          },
          scales: {
            x: {
              stacked: true,
            },
            y: {
              stacked: true,
            },
          },
        },
      });
    }
  }

  // Diagramme Repartition du nombre dadmis par famille de metier et par catégorie
  generateCategoryChart() {
    this.utilisateurService
      .getAdmittedByFamilyAndGender()
      .pipe(
        tap((dataGlobal) => {
          const c1Data = [
            dataGlobal?.['INTELLIGENCE ARTIFICIELLE ET DATA']?.C1,
            dataGlobal?.['e-BUSINESS']?.C1,
            dataGlobal?.['DÉVELOPPEMENT LOGICIEL']?.C1,
            dataGlobal?.['TECHNOLOGIES EMERGENTES ET CYBERSECURITE']?.C1,
          ];

          const c2Data = [
            dataGlobal?.['INTELLIGENCE ARTIFICIELLE ET DATA']?.C2,
            dataGlobal?.['e-BUSINESS']?.C2,
            dataGlobal?.['DÉVELOPPEMENT LOGICIEL']?.C2,
            dataGlobal?.['TECHNOLOGIES EMERGENTES ET CYBERSECURITE']?.C2,
          ];

          const c3Data = [
            dataGlobal?.['INTELLIGENCE ARTIFICIELLE ET DATA']?.C3,
            dataGlobal?.['e-BUSINESS']?.C3,
            dataGlobal?.['DÉVELOPPEMENT LOGICIEL']?.C3,
            dataGlobal?.['TECHNOLOGIES EMERGENTES ET CYBERSECURITE']?.C3,
          ];

          const c4Data = [
            dataGlobal?.['INTELLIGENCE ARTIFICIELLE ET DATA']?.C4,
            dataGlobal?.['e-BUSINESS']?.C4,
            dataGlobal?.['DÉVELOPPEMENT LOGICIEL']?.C4,
            dataGlobal?.['TECHNOLOGIES EMERGENTES ET CYBERSECURITE']?.C4,
          ];

          const c5Data = [
            dataGlobal?.['INTELLIGENCE ARTIFICIELLE ET DATA']?.C5,
            dataGlobal?.['e-BUSINESS']?.C5,
            dataGlobal?.['DÉVELOPPEMENT LOGICIEL']?.C5,
            dataGlobal?.['TECHNOLOGIES EMERGENTES ET CYBERSECURITE']?.C5,
          ];

          const c6Data = [
            dataGlobal?.['INTELLIGENCE ARTIFICIELLE ET DATA']?.C6,
            dataGlobal?.['e-BUSINESS']?.C6,
            dataGlobal?.['DÉVELOPPEMENT LOGICIEL']?.C6,
            dataGlobal?.['TECHNOLOGIES EMERGENTES ET CYBERSECURITE']?.C6,
          ];

          this.setCategoryChart(
            'canvasGlobal',
            c1Data,
            c2Data,
            c3Data,
            c4Data,
            c5Data,
            c6Data,
            "Répartition du nombre d'admis retenus par famille de métier et par catégorie",
            {
              c1: 'rgba(201, 203, 207, 0.2)',
              c2: 'rgba(75, 192, 192, 0.2)',
              c3: 'rgba(255, 205, 86, 0.2)',
              c4: 'rgba(255, 159, 64, 0.2)',
              c5: 'rgba(0, 128, 0, 0.2)',
              c6: 'rgba(255, 0, 255, 0.2)',
            }
          );
        })
      )
      .subscribe();
  } 

  // Methode pour dessiner le diagramme Répartition du nombre dadmis par famille de métier et par catégorie
setCategoryChart(
  canvasName: string,
  c1Data: number[],
  c2Data: number[],
  c3Data: number[],
  c4Data: number[],
  c5Data: number[],
  c6Data: number[],
  title: string,
  colors: {
    c1: string;
    c2: string;
    c3: string;
    c4: string;
    c5: string;
    c6: string;
  }
) {
  const canvas = document.getElementById(canvasName) as HTMLCanvasElement;
  const ctx = canvas.getContext('2d');

  if (ctx) {
    this.chart2 = new Chart(ctx, {
      type: 'bar',
      data: {
        labels: ['IA/D', 'E-Bus', 'DEV-LOG', 'TE/Cybs'],
        datasets: [
          {
            label: 'C1',
            data: c1Data,
            backgroundColor: colors.c1,
            borderColor: 'rgb(54, 162, 235)',
            borderWidth: 1,
          },
          {
            label: 'C2',
            data: c2Data,
            backgroundColor: colors.c2,
            borderColor: 'rgb(255, 99, 132)',
            borderWidth: 1,
          },
          {
            label: 'C3',
            data: c3Data,
            backgroundColor: colors.c3,
            borderColor: 'rgb(255, 205, 86)',
            borderWidth: 1,
          },
          {
            label: 'C4',
            data: c4Data,
            backgroundColor: colors.c4,
            borderColor: 'rgb(255, 159, 64)',
            borderWidth: 1,
          },
          {
            label: 'C5',
            data: c5Data,
            backgroundColor: colors.c5,
            borderColor: 'rgb(0, 128, 0)',
            borderWidth: 1,
          },
          {
            label: 'C6',
            data: c6Data,
            backgroundColor: colors.c6,
            borderColor: 'rgb(255, 0, 255)',
            borderWidth: 1,
          },
        ],
      },
      options: {
        plugins: {
          title: {
            display: true,
            text: title,
          },
        },
        responsive: true,
        interaction: {
          intersect: false,
        },
        scales: {
          x: {
            stacked: true,
          },
          y: {
            stacked: true,
          },
        },
      },
    });
  }
}


getCountAdmisNoadmis(){
  this.utilisateurService.countAdmisNoAdmis().subscribe(
    (data : any)=>{
      this.countAdmis = data?.['coutAdmis'];
      this.countNoAdmis = data?.['countNodmis'];
      
      //// //console.log('Données non Admis:>', this.countAdmis);
      //// //console.log('Données non Admis:>', this.countNoAdmis);

      this.setTotalAdmis_NoAdmisChart('canvasCountAdmisNoAdmis',0,0,"Répartition des admis non admis",
        {
          Admis: 'rgba(75, 192, 192, 0.2)',
          NomAdmis: 'rgba(255, 99, 132, 0.2)',
        }
      );
    }
  )
}


setTotalAdmis_NoAdmisChart(
  canvasName: string,
  admisData: number,
  noAdmisData: number,
  title: string,
  colors: { Admis: string; NomAdmis: string }
) {
  const canvas = document.getElementById(canvasName) as HTMLCanvasElement;
  const ctx = canvas.getContext('2d');

  if (ctx) {
    this.chart = new Chart(ctx, {
      type: 'pie', 
      data : {
        labels: [
          'Admis',
          'Non admis',
        ],
        datasets: [{
          label: 'My First Dataset',
          data: [this.countAdmis,this.countNoAdmis],
          backgroundColor: [
            'rgb(54, 162, 235)',
            'rgb(255, 99, 132)',
            // 'rgb(255, 205, 86)'
          ],
          hoverOffset: 4
        }]
      },

      

      options: {
        plugins: {
          title: {
            display: true,
            text: title,
          },
        },
        responsive: true,
        interaction: {
          intersect: false,
        },
        scales: {
          x: {
            stacked: true,
          },
          y: {
            stacked: true,
          },
        },
      },
    });
  }
}

}
